import { styled } from '@mui/system';
import DialogContent from '@mui/material/DialogContent';

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  '&.MuiDialogContent-root': {
    padding: 0,
    width: '396px',
    borderRadius: '8px',
    [theme.breakpoints.down('sm')]: {
      width: 'auto'
    }
  }
}));

export default StyledDialogContent;
